import React, { useEffect, useState } from 'react'
import RegisterCard from '../../../../components/cards/RegisterCard'
import {
  Box,
  FormControl,
  FormLabel,
  Grid,
  Button,
  styled,
  CircularProgress,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import lightTheme from '../../../../styles/theme/lightTheme'
import { Slide, toast, ToastContainer } from 'react-toastify'
import { useSelector } from 'react-redux'
import TextInputValue from '../../../../components/inputs/TextInputValue'
import Api from '../../../../services/api.service'
import { handlingErrors } from '../../../../utils'
import TextareaInputClassicValue from '../../../../components/inputs/TextareaInputClassicValue'

const CustomFormControl = styled(FormControl)(({ theme }) => ({
  display: 'flex',
  rowGap: '5px',
}))

const CustomFormLabel = styled(FormLabel)(({ theme }) => ({
  fontFamily: 'Century Gothic Bold',
  fontSize: 10,
  lineHeight: '140%',
  letterSpacing: '0.2px',
  color: lightTheme.palette.text.primary,

  [lightTheme.breakpoints.up('sm')]: {
    fontSize: 12,
  },
  [lightTheme.breakpoints.up('lg')]: {
    fontSize: 14,
  },
}))

const ContactForm = () => {
  const { t } = useTranslation()
  const currentUser = useSelector((state) => state.userAuth.user)

  const [form, setForm] = useState({
    type: 'company',
    raisonSocial: '',
    nom: '',
    sujet: '',
    email: '',
    message: '',
  })

  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
  }

  useEffect(() => {
    if (currentUser && currentUser.data) {
      setForm({
        ...form,
        raisonSocial: currentUser.data.raisonSocial,
        nom: currentUser.data.nom + ' ' + currentUser.data.prenom,
        email: currentUser.data.email,
      })
    }
  }, [currentUser])

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      console.log('Form data:', form)

      const result = await Api.contact.send(form)
      const handling = handlingErrors(result)

      /* if (handling.status === 401) {
        dispatch(userLogout())
        return
      } */

      if (handling.ok) {
        toast.success(t('successMessage.send'), {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        })
        if (currentUser && currentUser.data) {
          setForm({
            ...form,
            raisonSocial: currentUser.data.raisonSocial,
            nom: currentUser.data.nom + ' ' + currentUser.data.prenom,
            email: currentUser.data.email,
            sujet: '',
            message: '',
          })
        } else {
          setForm({
            type: 'company',
            raisonSocial: '',
            nom: '',
            sujet: '',
            email: '',
            message: '',
          })
        }
      }
      await new Promise((r) => setTimeout(r, 500))
    } catch (err) {
      console.error(err)
    }

    setLoading(false)
  }

  return (
    <RegisterCard>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
        }}
      >
        {/*   <Typography variant="h6" fontWeight="bold">
          {t('contact.title', 'Contact us')}
        </Typography> */}

        <Grid container spacing={2}>
          {/* Name */}
          <Grid item xs={12} sm={6}>
            <CustomFormControl fullWidth>
              <CustomFormLabel>{t('contact.fullName')}</CustomFormLabel>
              <TextInputValue
                placeholder={t('contact.fullName')}
                width={'100%'}
                type={'text'}
                name="nom"
                value={form.nom}
                handleChange={handleChange}
              />
            </CustomFormControl>
          </Grid>

          {/* Email */}
          <Grid item xs={12} sm={6}>
            <CustomFormControl fullWidth>
              <CustomFormLabel>{t('contact.email')}</CustomFormLabel>
              <TextInputValue
                placeholder={t('contact.email')}
                width={'100%'}
                type={'email'}
                name="email"
                value={form.email}
                handleChange={handleChange}
              />
            </CustomFormControl>
          </Grid>
          <Grid item xs={12}>
            <CustomFormControl fullWidth>
              <CustomFormLabel>{t(`contact.companyName`)}</CustomFormLabel>
              <TextInputValue
                placeholder={t('contact.companyName')}
                width={'100%'}
                type={'text'}
                name="raisonSocial"
                value={form.raisonSocial}
                handleChange={handleChange}
              />
            </CustomFormControl>
          </Grid>
          <Grid item xs={12}>
            <CustomFormControl fullWidth>
              <CustomFormLabel>{t('contact.subject')}</CustomFormLabel>
              <TextInputValue
                placeholder={t('contact.subject')}
                width={'100%'}
                type={'text'}
                name="sujet"
                value={form.sujet}
                handleChange={handleChange}
              />
            </CustomFormControl>
          </Grid>

          {/* Message */}
          <Grid item xs={12}>
            <CustomFormControl fullWidth>
              <CustomFormLabel>{t('contact.message')}</CustomFormLabel>
              <TextareaInputClassicValue
                placeholder={t('contact.message')}
                width={'100%'}
                type={'text'}
                name="message"
                value={form.message}
                onChange={handleChange}
                multiline
                rows={4}
              />
            </CustomFormControl>
          </Grid>
        </Grid>

        {/* Submit */}
        <Button
          type="submit"
          variant="contained"
          disabled={loading}
          sx={{
            borderRadius: '30px',
            fontWeight: 'bold',
            textTransform: 'none',
            background: 'linear-gradient(135deg, #A4ADFF 0%, #7F8CFF 100%)',
            boxShadow: '0 4px 14px rgba(164,173,255,0.4)',
            color: 'white',
            textTransform: 'uppercase',
            fontFamily: 'Century Gothic Bold',
            fontSize: 10,
            lineHeight: '140%',
            letterSpacing: '0.2px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            columnGap: '10px',
            borderRadius: '3px',
            cursor: 'pointer',
            padding: '0 10px',
            alignSelf: 'end',
            width: '100%',
            opacity: loading ? '0.5' : '1',

            '&:hover': {
              backgroundColor: lightTheme.palette.primary.main,
            },
            '&:active': {
              backgroundColor: lightTheme.palette.primary.b2,
            },
            [lightTheme.breakpoints.up('xs')]: {
              fontSize: 10,
              height: 41,
            },
            [lightTheme.breakpoints.up('sm')]: {
              fontSize: 14,
              height: 41,
            },
            [lightTheme.breakpoints.up('lg')]: {
              height: 40,
            },
          }}
        >
          {loading ? (
            <>
              <CircularProgress size={20} color="inherit" />
              {' ' + t('contact.sending')}
            </>
          ) : (
            t('contact.send')
          )}
        </Button>
      </Box>{' '}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        closeButton={false}
        transition={Slide}
        className={'toast'}
      />
    </RegisterCard>
  )
}

export default ContactForm
